import { Bar, BarChart, XAxis, YAxis } from "recharts";
import {
  ChartContainer,
  ChartTooltip,
  ChartTooltipContent,
} from "@/components/ui/chart";
import { useMonthlyDailyStats } from "@/hooks/useStats";
import { Skeleton } from "@/components/ui/skeleton";

interface MonthlyDailyChartProps {
  companyId?: string;
  period?: string;
}

export const MonthlyDailyChart = ({
  companyId,
  period,
}: MonthlyDailyChartProps) => {
  const { data, isLoading, error } = useMonthlyDailyStats(period, companyId);

  if (isLoading) {
    return (
      <div className="h-64 flex items-center justify-center">
        <Skeleton className="h-full w-full" />
      </div>
    );
  }

  if (error) {
    return (
      <div className="h-64 flex items-center justify-center">
        <p className="text-muted-foreground">
          Erreur lors du chargement des données
        </p>
      </div>
    );
  }

  if (!data || data.length === 0) {
    return (
      <div className="h-64 flex items-center justify-center">
        <p className="text-muted-foreground">Aucune donnée disponible</p>
      </div>
    );
  }

  // Configuration du graphique
  const chartConfig = {
    count: {
      label: "Sessions",
      color: "#051941", // Couleur primary
    },
  };

  return (
    <div className="w-full h-64 sm:h-80 lg:h-96">
      <ChartContainer
        config={chartConfig}
        className="h-full w-full [&]:!aspect-auto"
      >
        <BarChart
          data={data}
          margin={{
            left: 0,
            right: 0,
            top: 10,
            bottom: period === "month" ? 40 : 10,
          }}
        >
          <XAxis
            dataKey="label"
            tickLine={false}
            tickMargin={period === "month" ? 8 : 10}
            axisLine={false}
            tickFormatter={(value) => value}
            interval={period === "month" ? 0 : undefined}
            tick={{ fontSize: 10 }}
            angle={period === "month" ? -45 : 0}
            textAnchor={period === "month" ? "end" : "middle"}
            {...(period === "month" && { height: 60 })}
            className="text-xs"
          />
          <YAxis hide />
          <ChartTooltip content={<ChartTooltipContent />} />
          <Bar dataKey="count" fill="var(--color-count)" radius={4} />
        </BarChart>
      </ChartContainer>
    </div>
  );
};
